import { FunctionComponent } from "react";
import { IconProps } from "./IconProps";

const CollapseIcon: FunctionComponent<IconProps> = ({
  size = 24,
  color,
  testID,
}) => (
  <svg
    width={size}
    height={size}
    color={color}
    data-testid={testID}
    fill="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M12 9.92899L15.821 13.75C16.235 14.164 16.907 14.164 17.321 13.75C17.735 13.336 17.735 12.664 17.321 12.25L12.707 7.63599C12.316 7.24499 11.683 7.24499 11.293 7.63599L6.67903 12.25C6.26503 12.664 6.26503 13.336 6.67903 13.75C7.09303 14.164 7.76503 14.164 8.17903 13.75L12 9.92899Z" />
  </svg>
);

export { CollapseIcon };
